import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.SliderRoot),
  () => import('./Slider'),
  (Slider) => {
    ComponentUtil.binder(Hooks.SliderRoot, Slider);
  },
);
